import { ModalPageLayout } from '../../../components/ModalPageLayout';
import SelectorEngine from '../../../utils/dom/selector-engine';

const SELECTOR_WRAPPER = '.p-household-account-inviation-link-expired-page';

class InvitationLinkExpired {
	constructor(element) {
		this._element = element;
		if (!this._element) return;
		this.init();
	}

	init() {
		this.modalInstance = new ModalPageLayout(this._element);
		this.modalInstance.showModal();
	}
}

const element = SelectorEngine.findOne(SELECTOR_WRAPPER);
const invitationLinkExpired = new InvitationLinkExpired(element);
export default invitationLinkExpired;
